import queryString from 'query-string';
import moment from 'moment-timezone';

import {
  CheckoutSession,
  CheckoutType,
  MerchantSetting,
  PayWidget,
  SettingNames,
  Status,
} from 'services/checkout-service/models';

import { UsableMerchantSettings } from '.';

export const extractMerchantSettings = (settings: MerchantSetting[]) => {
  return settings.reduce((acc, { name, value }) => {
    if (SettingNames[name]) {
      return {
        ...acc,
        [SettingNames[name]]: value
      };
    }

    return acc;
  }, {} as UsableMerchantSettings);
};

export const mapToCheckoutSession = (
  payWidgetDetails: PayWidget
): CheckoutSession => {
  return {
    id: payWidgetDetails.uuid,
    status: Status.UNPAID,
    type: CheckoutType.PAY_WIDGETS,
    merchant: payWidgetDetails.merchant,
    widgetType: payWidgetDetails.widgetDetail.type,
    shoppingCart: {
      total: payWidgetDetails.amount,
      minAmount: payWidgetDetails.minAmount
    },
    createdTime: moment(payWidgetDetails.createdTime).valueOf(),
    ...(payWidgetDetails.convenienceFee && {
      additionalCharges: [
        {
          type: 'CONVENIENCE_FEE',
          amount: payWidgetDetails.convenienceFee
        }
      ]
    }),
  };
};

export const extractBasePath = (pathname: string) => {
  const { url } = queryString.parseUrl(pathname);

  return url.trim().split('/')[1] || url.replace(/\//g, '');
};
